import React from 'react'

import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement>

const SectionContainer: React.FC<Props> = ({ className, style, ...props }) => (
  <section
    className={cn(className)}
    style={{ maxWidth: '640px', ...style }}
    {...props}
  />
)

export default SectionContainer
